import * as Sentry from '@sentry/react';

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_EXECUTION_ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    enabled: !!process.env.REACT_APP_SENTRY_DSN,
});

export default Sentry;
